/*=========================================================================================
  File Name: actions.js
  Description: Cart Actions
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import netsService from "../../../services/checkouts/queries";

export default {
    async getCartInfoAction( { commit, state }, payload) {
        await netsService.getCartInfo().then( response => {
          console.log(response);
          commit('SET_CART_INFO_STATE', response)
          commit('SET_ORDER_INFO_STATE', response)
        })
      },

   
}